export default function TrainsRoundtripController(
    $scope,
    $state,
    $timeout,
    trainsFactory,
    flightsUtils,
    userService,
    l10nService,
    timeService,
) {
    'ngInject';

    const vm = this;
    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        trainsFactory.resetSegmentFilterData();
        getPreviousSearchResults();
    }

    $scope.showOptions = trainsFactory.showOptions;
    $scope.flightType = 'roundtrip';
    $scope.previousSearches = [];

    $scope.updateArrival = function(segmentIndex, isArrival) {
        $scope.params.TicketSearchSegments[segmentIndex]._isArrivalTime = isArrival;
    };

    const initialDepartDate = timeService.getDateInUserRegionFormatOrCurrentDate($scope.params.TicketSearchSegments[0]._date);
    const initialReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate($scope.params.TicketSearchSegments[1]._date);

    $scope.optionsDepart = {
        placeholder: l10nService.localize('Date'),
        required: true,
        months: 2,
        start: initialDepartDate,
        after: moment().hours() >= _.last($scope.options.time).startHour
            ? moment()
            : moment().add({days: -1}),
        before: trainsFactory.getMaxBookDate(),
        dependentPikers: ['optionsReturn'],
    };

    $scope.optionsReturn = {
        placeholder: l10nService.localize('Date'),
        required: true,
        months: 2,
        start: initialReturnDate,
        after: moment(initialDepartDate).add({days: -1}),
        before: trainsFactory.getMaxBookDate(),
    };

    $scope.findFlights = findFlights;
    $scope.repeatSearch = repeatSearch;

    $scope.$watch('params.TicketSearchSegments[0]._date', departTimeWatcher);
    $scope.$watch('params.TicketSearchSegments[1]._date', returnTimeWatcher);
    $scope.$watch('params.TicketSearchSegments[0]._time', returnTimeWatcher, true);
    $scope.$watch('params.TicketSearchSegments[0]._date',
        flightsUtils.refreshReturnedDate.bind($scope.params.TicketSearchSegments)
    );

    function navigateToResultsRoute() {
        $state.go('main.trains.results');
    }

    function departTimeWatcher() {
        flightsUtils.departureTimeWatcher(
            $scope.params.TicketSearchSegments[0]._date,
            $scope.options.time0,
            $scope.params.TicketSearchSegments[0]._time,
            $scope.options.time
        );
    }

    function findFlights() {
        $scope.params.flightType = 'roundtrip';
        trainsFactory.fetchFlights(angular.copy($scope.params), false,
            {
                outbound: $scope.params.TicketSearchSegments[0]._isArrivalTime,
                inbound: $scope.params.TicketSearchSegments[1]._isArrivalTime,
            })
            .then(navigateToResultsRoute);
    }

    function repeatSearch(search) {
        $scope.showOptions = flightsUtils.moreOptionsApplied(search);

        trainsFactory.getSearch(search.Id)
            .then(({data}) => {
                angular.forEach(data.TicketSearchSegments, (segment, i) => {
                    segment.IsDepartureCity = search.SearchSegments[i].IsDeparturePointCity;
                    segment.IsArrivalCity = search.SearchSegments[i].IsArrivalPointCity;
                });

                $scope.updateArrival(0, data.TicketSearchSegments[0].DayTimeFilterSource);
                $scope.updateArrival(1, data.TicketSearchSegments[1].DayTimeFilterSource);

                trainsFactory.params.recreate(search, data, $scope.options, $scope.flightType);
                return trainsFactory.fetchFlights(data, true);
            })
            .then(navigateToResultsRoute);
    }

    function getPreviousSearchResults() {
        trainsFactory.getAllPreviousSearches(1)
            .then(({data}) => $scope.previousSearches = data);
    }

    function returnTimeWatcher() {
        flightsUtils.returnTimeWatcher(
            $scope.params.TicketSearchSegments[0]._date,
            $scope.params.TicketSearchSegments[1]._date,
            $scope.options.time1,
            $scope.params.TicketSearchSegments[0]._time,
            $scope.params.TicketSearchSegments[1]._time,
            $scope.options.time
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/train/controllers/trains-roundtrip-controller.js